import React, { useEffect, useState } from 'react';
import '../Estilos/EstiloBotao.css';
import useWindowSize from '../Hooks/windowSize';

/**
 * @param nome (string) Título do botão.
 * @param visivel (bool) Visível ou não.
 * @function clicado (void) Evento botão chamado.
 */
export default function BotaoCadastro({ nome, visivel, clicado }) {
  const windowSize = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(windowSize.width < 768);
  }, [windowSize]);

  return (
    <div
      style={{
        width: '98%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: isMobile ? 'center' : 'flex-end',
        height: 60,
        alignItems: 'flex-start',
        margin: 10,
      }}
    >
      {visivel ? (
        <button id="BotaoCadastro" onClick={() => clicado()}>
          {nome}
        </button>
      ) : null}
    </div>
  );
}
